import { pageViewTypes } from "@constants/tracking";
import ArticlesRouteContainer from "@features/articles/containers/ArticlesRouteContainer";
import useAnalytics from "@hooks/useAnalytics";
import { useAppStore } from "@hooks/useAppStore";
import { Redirect } from "expo-router";

const LibraryRoute = () => {
	useAnalytics({
		type: pageViewTypes.library,
	});
	const navigationRoutes = useAppStore((state) => state.navigation);

	const isArticleEnabled = navigationRoutes?.routes?.main?.find(
		(route) =>
			route.name === "(articles)/articles" || route.name === "articles",
	)?.enabled;

	if (!isArticleEnabled) {
		return <Redirect href="/(protected)/(tabs)/home" />;
	}
	return <ArticlesRouteContainer />;
};

export default LibraryRoute;
